const SETCONNECTION = 'SETCONNECTION';
const SETCONNECTIONSTATE = 'SETCONNECTIONSTATE';
const SETHEATS = 'SETHEATS';
const SETSELECTEDHEAT = 'SETSELECTEDHEAT';
const SETHEATSTATE = 'SETHEATSTATE';
const SETRESULTIDS = 'SETRESULTIDS';
const REGISTERHUB = 'REGISTERHUB';
const UNREGISTERHUB = 'UNREGISTERHUB';
const UPDATEEVENTSTATE = 'UPDATEEVENTSTATE';
const SETLOGIN = 'SETLOGIN';
const LOGOUT = 'LOGOUT';
const UNSETHEATDATA = 'UNSETHEATDATA';
const SETHEARTBEAT = 'SETHEARTBEAT';
const RANKUPDATE = 'RANKUPDATE';
const SETHEIGHTS = 'SETHEIGHTS';
const SETDROPEDENTRANTS = 'SETDROPEDENTRANTS';
const SETWKBHELP = 'SETWKBHELP';
const SETEDITENTRYID = 'SETEDITENTRYID';
const UPDATEENTRY = 'UPDATEENTRY';


export default {
    SETCONNECTION,
    SETCONNECTIONSTATE,
    SETHEATS,
    SETHEATSTATE,
    SETRESULTIDS,
    REGISTERHUB,
    UNREGISTERHUB,
    SETSELECTEDHEAT,
    UPDATEEVENTSTATE,
    SETLOGIN,
    LOGOUT,
    SETHEARTBEAT,
    RANKUPDATE,
    UNSETHEATDATA,
    SETHEIGHTS,
    SETDROPEDENTRANTS,
    SETWKBHELP,
    SETEDITENTRYID,
    UPDATEENTRY,
};